import { gql } from '@apollo/client';

export const COLOR_FIELDS = gql`
  fragment ColorFields on Color {
    id
    short
    nameDe
    nameEn
    hexColorValue
  }
`;

export const FILE_FIELDS = gql`
  fragment FileFields on File {
    id
    path
    clientName
    clientSize
    clientType
  }
`;

export const ALLOY_FIELDS = gql`
  fragment AlloyFields on Alloy {
    id
    short
    nameDe
    nameEn
    sortingIndex
    color {
      ...ColorFields
    }
  }
  ${COLOR_FIELDS}
`;

export const GEM_SPACING_FIELDS = gql`
  fragment GemSpacingFields on GemSpacing {
    id
    short
    option
    distance
    spacingUnit
    minProductionDistance
  }
`;

export const GEM_CUT_FIELDS = gql`
  fragment GemCutFields on GemCut {
    id
    short
    nameDe
    nameEn
    shape
  }
`;

export const GEM_FIELDS = gql`
  fragment GemFields on Gem {
    id
    short
    nameDe
    nameEn
    carat
    diameter
    width
    length
    height
    cut {
      ...GemCutFields
    }
  }
  ${GEM_CUT_FIELDS}
`;

export const GEM_CLASS_FIELDS = gql`
  fragment GemClassFields on GemClass {
    id
    short
    name
    color {
      ...ColorFields
    }
  }
  ${COLOR_FIELDS}
`;

export const SETTING_TYPE_FIELDS = gql`
  fragment SettingTypeFields on GemSettingType {
    id
    short
    styleType
    layoutType
    orientation
    layoutDetails {
      strategy
      padding
      entries {
        gemId
        offsetX
        offsetY
      }
    }
    spacings {
      ...GemSpacingFields
    }
    cut {
      id
      short
      shape
    }
    allowedGems(width: 20.0, height: 10.0) {
      ...GemFields
    }
  }
  ${GEM_SPACING_FIELDS}
  ${GEM_FIELDS}
`;

export const SURFACE_FIELDS = gql`
  fragment SurfaceFields on Surface {
    id
    short
    nameDe: name_de
    nameEn: name_en
    averageRoughnessValue: average_roughness_value
    roughnessFile: roughness_file {
      id
      path
    }
    normalFile: normal_file {
      id
      path
    }
  }
`;

export const RING_PROFILE_FIELDS = gql`
  fragment RingProfileFields on RingProfile {
    id
    name
    short
    labelDe
    labelEn
    formFactor
    dxfFiles {
      id
      file {
        id
        path
        clientName
      }
    }
    dxfLoopFiles {
      id
      file {
        id
        path
        clientName
      }
    }
  }
`;

export const MODEL_FILE_FIELDS = gql`
  fragment ModelFileFields on ModelFile {
    id
    width
    carat
    file {
      ...FileFields
    }
  }
  ${FILE_FIELDS}
`;

export const RING_PARTIAL_FIELDS = gql`
  fragment RingPartialFields on RingPartial {
    id
    index
    name
    fixedWidth
    ringProfile {
      ...RingProfileFields
    }
    ringSegments {
      id
      short
      count
      direction
      primaryFormValue
      secondaryFormValue
      tertiaryFormValue
    }
    alloys {
      ...AlloyFields
    }
    surfaces {
      ...SurfaceFields
    }
    gems {
      ...GemFields
    }
    gemClasses {
      ...GemClassFields
    }
    settingTypes {
      ...SettingTypeFields
    }
  }
  ${RING_PROFILE_FIELDS}
  ${ALLOY_FIELDS}
  ${SURFACE_FIELDS}
  ${GEM_FIELDS}
  ${GEM_CLASS_FIELDS}
  ${SETTING_TYPE_FIELDS}
`;

export const RING_TEMPLATE_FIELDS = gql`
  fragment RingTemplateFields on RingTemplate {
    id
    short
    nameDe
    nameEn
    descriptionDe
    descriptionEn
    gender
    multipart
    modelFiles {
      ...ModelFileFields
    }
    ringPartials {
      ...RingPartialFields
    }
  }
  ${MODEL_FILE_FIELDS}
  ${RING_PARTIAL_FIELDS}
`;

export const RING_PRICING_FIELDS = gql`
  fragment RingPricingFields on RingPricing {
    solitaireGemB2b
    ringB2b
    totalB2b
    solitaireGemB2b2c
    eternityGemB2b
    eternityGemB2b2c
    ringB2b2c
    totalB2b2c
  }
`;
